import * as React from 'react';

export enum NumberStyle {
	Editor,
	Game,
}

type Props = {
	count: number;
	numberStyle?: NumberStyle;
};

export default function InstructionCountContainer({
	count,
	numberStyle = NumberStyle.Game,
}: Props): React.ReactElement | null {
	const classNames = ['InstructionCountContainer'];

	// Make sure the count string is 0-padded, two digits.
	let countString = '000' + count;
	countString = countString.substr(countString.length - 2, 2);

	if (numberStyle === NumberStyle.Editor) {
		countString = '' + count;

		if (count === 0) {
			classNames.push('InstructionCountContainer--fadedCount');
		}
	}

	return <div className={classNames.join(' ')}>{countString}</div>;
}
